import PropTypes from 'prop-types';

const Coordinates = {
  longitude: PropTypes.number,
  latitude: PropTypes.number,
};

export const CoordinatesShape = PropTypes.shape(Coordinates);
export const CoordinatesExact = PropTypes.exact(Coordinates);
